<script setup>
import { PLACEHOLDER_AVATAR_PATH } from '@/constants/global'
import { usePhysicianStore } from '@/store/pinia/physician'
import { computed, ref } from 'vue'

const props = defineProps({
  size: {
    type: Number,
    default: 82,
  },
})

const defaultAvatar = PLACEHOLDER_AVATAR_PATH

const physicianStore = usePhysicianStore()
const hasError = ref(false)

const currentSrc = computed(() => {
  if (hasError.value || !physicianStore.avatarUrl) {
    return defaultAvatar
  }
  return physicianStore.avatarUrl
})

function handleError() {
  hasError.value = true
}
</script>

<template>
  <img :src="currentSrc" alt="foto de perfil" :width="size" :height="size" @error="handleError" />
</template>
